import { render, staticRenderFns } from "./RTCloseButton.vue?vue&type=template&id=16982089&scoped=true&"
import script from "./RTCloseButton.vue?vue&type=script&lang=js&"
export * from "./RTCloseButton.vue?vue&type=script&lang=js&"
import style0 from "./RTCloseButton.vue?vue&type=style&index=0&id=16982089&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16982089",
  null
  
)

export default component.exports